module.exports = __webpack_public_path__ + "static/media/chewy_small_logo.4d16dfcd.png";